import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "vuejs-loading vuejs-loading-circular"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  "class": "vuejs-loading-spinner vuejs-loading-spinner-circular"
}, [/*#__PURE__*/_createElementVNode("svg", {
  "class": "vuejs-loading-circular",
  viewBox: "25 25 50 50"
}, [/*#__PURE__*/_createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none"
})])], -1);

var _hoisted_3 = {
  "class": "vuejs-loading-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", _hoisted_3, [_renderSlot(_ctx.$slots, "default")])]);
}